import { useEffect, useState } from "react";
import { QueryParams } from "../types";

export type SearchCoreMethods = {
  searchParamsFiltersOnly: {
    [key: string]: any;
  };
  navigateToNextSearch: (newParams: QueryParams) => void;
};

export const useSearchBatched = (
  useSearch: SearchCoreMethods,
  whitelist?: string[]
) => {
  const { searchParamsFiltersOnly, navigateToNextSearch } = useSearch;

  const [workingParams, setWorkingParams] = useState<QueryParams>({
    ...searchParamsFiltersOnly,
  });
  const [dirtyParams, setDirtyParams] = useState<string[]>([]);

  useEffect(() => {
    // once we apply changes (or something external has changed the search ?), refresh
    //  our working params from the source of truth
    setWorkingParams({ ...searchParamsFiltersOnly });
  }, [searchParamsFiltersOnly]);

  useEffect(() => {
  }, [workingParams]);

  const batchApplyParams = () => {
    navigateToNextSearch(workingParams);
    setDirtyParams([]);
  };

  const batchClearParams = () => {
    const fieldsToClear = whitelist
      ? // if we have a whitelist, we only want to be blatting-out the whitelisted fields we know are safe
        whitelist
      : // otherwise, we are safe to just clear the entire query string
        Object.keys(workingParams);

    const clearingObject = fieldsToClear.reduce((acc, curr) => {
      acc[curr] = undefined;
      return acc;
    }, {} as QueryParams);

    navigateToNextSearch(clearingObject);
    setWorkingParams({});
    setDirtyParams([]);
  };

  const addParam = (
    name: string,
    value: string | number | string[] | number[] | undefined
  ) => {
    console.log("calling add param...")
    setWorkingParams({ ...workingParams, [name]: value });
    const nextDirtyFields = dirtyParams.includes(name)
      ? [...dirtyParams]
      : [...dirtyParams, name];
    setDirtyParams(nextDirtyFields);
  };

  const updateMultipleParams = (params: { [key: string]: string | number | string[] | number[] | undefined }) => {
    setWorkingParams({ ...workingParams, ...params });
    const nextDirtyFields = Object.keys(params).reduce((acc, curr) => {
      return acc.includes(curr)
        ? [...acc]
        : [...acc, curr];
    }, [...dirtyParams]);
    setDirtyParams(nextDirtyFields);
  }

  return {
    searchParamsFiltersOnly,
    workingParams,
    dirtyParams,
    addParam,
    batchApplyParams,
    batchClearParams,
    updateMultipleParams,
  };
};
